import {ChangeDetectorRef, Component, OnDestroy} from '@angular/core';
import {DialogAdapter, DialogParams, DialogResult} from '../../models/dialog-param';
import {FormGroup} from '@angular/forms';
import {CreateEventFormValidator} from './create-event-form.validator';
import {RoomSetting} from '../../models/room-setting';
import {SharedValueService} from '../../services/shared-value.service';
import {GroupSetting} from '../../models/group-setting';
import {BUTTON_NAME, DAY_OF_WEEK, TypeRoom} from '../../common/constants';
import {RRule, rrulestr} from 'rrule';
import * as moment from 'moment';
import {Helper} from '../../common/helper';
import {Subscription} from 'rxjs/Rx';
import {RoomService} from '../../services/room.service';
import {GroupService} from '../../services/group.service';
import {UserService} from '../../services/user.service';
import {environment} from '../../../environments/environment';
import {AuthenticationService} from '../../services/authentication.service';
import 'select2';
import {Select2OptionData} from 'ng2-select2';
import {UserSetting} from '../../models/user-setting';

declare const $: any;

@Component({
  selector: 'app-modal-create-event',
  templateUrl: './modal-event.component.html',
  styleUrls: ['./modal-event.component.scss'],
  providers: [CreateEventFormValidator],
  preserveWhitespaces: false
})
export class ModalEventComponent implements DialogAdapter, OnDestroy {
  public TypeRoom: typeof TypeRoom = TypeRoom;
  params: DialogParams;
  prop: any;
  eventFormGroup: FormGroup;
  groupSubscription: Subscription;
  roomSubscription: Subscription;
  timePicker = [];
  rooms: RoomSetting[] = [];
  groups: GroupSetting[] = [];
  dayOfWeek = [];
  dateOfEvent = {
    eventDate: '',
    startTime: '',
    endTime: ''
  };
  repeatStartDate = '';
  repeatEndDate = '';
  isRepeatEvent = false;
  messageError: any;
  dateError = {
    eventDate: false,
    startTime: false,
    endTime: false
  };
  repeateDateError = {
    repeatStartDate: false,
    repeatEndDate: false
  };
  isInitial = true;
  isCheckedAll = false;
  isValidDateTime = true;
  isValidRepeatEvent = true;
  invalidTimeMsg = '';
  invalidRepeatEventMsg = '';
  subscription: Subscription;
  minDate: any;
  maxDate_repeatStart: any;
  maxDate_repeatEnd: any;
  formError = {
    summary: '',
    email: '',
  };
  options: Select2Options;
  value: string[];
  emails = [];
  ajaxOptions: Select2AjaxOptions;
  lastResult = [];
  initData: Array<Select2OptionData> = [];
  userSession: UserSetting;

  constructor(private formValidator: CreateEventFormValidator,
              private sharedValueService: SharedValueService,
              private helper: Helper,
              private roomService: RoomService,
              private groupService: GroupService,
              private userService: UserService,
              private auth: AuthenticationService,
              private changeDetectorRef: ChangeDetectorRef) {
    this.helper._unsubsribe(this.roomSubscription);
    this.helper._unsubsribe(this.groupSubscription);
    this.userSession = this.sharedValueService.getUserSession();

    this.roomSubscription = this.roomService.getAllRooms().subscribe(rooms => {
      this.rooms = rooms;
     });

    this.groupSubscription = this.groupService.getAllGroups().subscribe(gr => {
      this.groups = gr;
    });
    this._setDateTime();
    this._setSelect2Init();
    this.helper._unsubsribe(this.subscription);
    this.subscription = sharedValueService.getHttpStatus().subscribe(status => {
    this.sharedValueService.waitingApiResponse.next(false);
      if (status) {
        if (this.prop && this.prop.hasOwnProperty('isAPICallError')) {
          this.prop.isAPICallError = false;
        }
        this.eventFormGroup.reset();
        this.params.subject.complete();
        setTimeout(() => {
          (<any>$('#theModal')).modal('hide');
          this.isInitial = true;
          this.helper._unsubsribe(this.subscription);
        });
      } else {
        if (this.prop) {
          this.prop.isAPICallError = true;
          this.prop.checkValidate = true;
        }
      }
    });
  }

  ngOnDestroy() {
    this.helper._unsubsribe(this.groupSubscription);
    this.helper._unsubsribe(this.roomSubscription);
  }

  private _setDateTime() {
    this.minDate = new Date();
    this.maxDate_repeatStart = moment().endOf('year');
    this.maxDate_repeatEnd = moment().endOf('year');
    DAY_OF_WEEK.forEach(item => {
      const date = JSON.parse(JSON.stringify(item));
      date['isChecked'] = false;
      this.dayOfWeek.push(date);
    });
    this.timePicker = this.helper.genTimePicker();
  }

  private _setSelect2Init() {
    const token = this.auth.getCurrentToken();
    this.ajaxOptions = {
      url: environment.apiURL + '/api/data/user/searchEmail',
      delay: 800,
      cache: true,
      transport: function(params, success, failure){
        params.beforeSend = function(request){
          request.setRequestHeader('Authorization', 'Bearer ' + token);
          request.setRequestHeader('Content-Type', 'application/json;charset=utf-8');
          request.setRequestHeader('Accept', 'application/json');
        };
        const $request = $.ajax(params);
        $request.then(success);
        $request.fail(failure);
        return $request;
      },
      data: (params: any) => {
        return {
          query: params.term,
        };
      },
      processResults: (data: any, params: any) => {
        params.page = params.page || 1;
        this.lastResult = data.data;
        return {
          results: $.map(data.data, function (obj) {
            return { id: obj.email, text: obj.email, name: obj.name};
          }),
        };
      }
    };
    this.options = {
      ajax: this.ajaxOptions,
      multiple: true,
      // tags: true,
      placeholder: 'Email...',
      tokenSeparators: [',', ' '],
      minimumInputLength: 3,
      // createTag: (params) => {
      //   if (this.lastResult.length === 0) {
      //     const term = params.term;
      //     if (!EMAIL_REGEX.test(term)) {
      //       return {otherResult: true, text: 'Please enter a valid email address (Ex: johndoe@domain.com)'};
      //     }
      //     return {id: term, text: term, newTag: true};
      //   }
      // },
      escapeMarkup:  function (markup) { return markup; },
      templateResult: this._formatRepo,
      templateSelection: this._formatRepoSelection
    };
  }

  private _formatRepo (repo) {
    if (repo.loading || repo.otherResult) {
      return repo.text;
    }
    const name = repo.name ? repo.name : '';
    let markup = '<div class="selectize-dropdown-content"><div><span>' + name +
      '</span><span style="font-size:12px;display:block; opacity:0.8; font-style:italic;">' + repo.text + '</span></div></div>';
    markup += '</div></div>';
    return markup;
  }

  private _formatRepoSelection (repo) {
    const name = repo.name ? repo.name : '';
    return  '<span class="name">' + name + '</span>' +
      '<span class="email" style="opacity:0.8;font-size:12px;margin-left:5px">&lt;' + repo.text + '&gt;</span>';
  }

  onValueChange(data: {value: string[]}) {
    this.emails = data.value;
    this.eventFormGroup.controls.email.setValue(this.emails.toString());
  }

  onModalInit() {
    this.prop = this.params.extraParams.initialValue;
    console.log(this.rooms);
    if (this.isInitial) {
      if (this.prop.eventModel.email) {
        const emails = this.prop.eventModel.email.split(',');
        emails.forEach(e => {
          this.initData = [...this.initData, {id: e, text: e}];
        });
        this.value = [...emails];
      }
      this.eventFormGroup = this.formValidator.createForm(this.prop.eventModel, this.rooms);

      if (this.userSession && !this.userSession.authority.AU_1) {
        for (let i = 0; i < this.rooms.length; i++) {
          // check room VIP
          if (this.rooms[i].type_room === TypeRoom.VIP) {
            if (this.prop.eventModel.eventId) {
              if (this.prop.eventModel.room_id !== this.rooms[i].id) {
                this.rooms.splice(i, 1);
                i--;
              }
            } else {
              this.rooms.splice(i, 1);
              i--;
            }
          }

        }
      }

      this.dateOfEvent.eventDate = moment(this.prop.eventModel.start).format('YYYY-MM-DD');
      this.dateOfEvent.startTime = moment(this.prop.eventModel.start).format('HH:mm');
      this.dateOfEvent.endTime = moment(this.prop.eventModel.end).format('HH:mm');
      if (this.prop.isDetail && this.prop.eventModel.repeat_rule) {
          this.isRepeatEvent = true;
          this.parseRRule(this.prop.eventModel.repeat_rule);
      }
      this.messageError = this.formValidator.getValidationMessages();
      this.isInitial = false;
      if (!this.changeDetectorRef['destroyed']) {
        this.changeDetectorRef.detectChanges();
      }
    } else {
      if (this.checkValidate()) {
        this.prop.checkValidate = false;
        this.params.subject.next(new DialogResult(BUTTON_NAME.OK, this.getPayload()));
      } else {
        this.helper.gotoInputError();
        this.prop.checkValidate = true;
      }
    }
  }

  getPayload(): any {
    const start = moment(this.dateOfEvent.eventDate + ' ' + this.dateOfEvent.startTime).format('YYYY-MM-DD HH:mm');
    const end = moment(this.dateOfEvent.eventDate + ' ' + this.dateOfEvent.endTime).format('YYYY-MM-DD HH:mm');
    const summary = this.eventFormGroup.controls.summary.value;
    if (summary) {
      this.eventFormGroup.controls.summary.setValue(summary.trim());
    }
    this.eventFormGroup.controls.start.setValue(start);
    this.eventFormGroup.controls.end.setValue(end);
    this.eventFormGroup.controls['start_date'].setValue(this.repeatStartDate);
    this.eventFormGroup.controls['end_date'].setValue(this.repeatEndDate);
    return {
      isAPICallError: this.prop.isAPICallError,
      checkValidate: this.prop.checkValidate,
      eventModel: this.eventFormGroup.value,
      rrule: this.isRepeatEvent ? this.setRRule() : null
    };
  }

  onChangeGroup(event: any) {
    this.eventFormGroup.controls['group_id'].setValue(event);
  }

  onChangeRoom(event: any) {
    this.eventFormGroup.controls['room_id'].setValue(event);
  }

  changeDatePicker(changedDate: any, format) {
    const date = moment(changedDate).format(format);
    return date;
  }

  onClickSelectRepeatEvent(value: boolean) {
    this.isRepeatEvent = !value;
    if ( this.isRepeatEvent) {
      if (this.prop.isDetail && this.prop.eventModel.repeat_rule) {
        this.parseRRule(this.prop.eventModel.repeat_rule);
      }
    } else {
      this.repeatEndDate = '';
      this.repeatStartDate = '';
      this.isCheckedAll = false;
      this.repeateDateError.repeatStartDate = false;
      this.repeateDateError.repeatEndDate = false;
      this.invalidRepeatEventMsg = '';
      this.dayOfWeek.forEach(item => item.isChecked = false);
    }
  }

  onClickSelectAll(value: boolean) {
    this.isCheckedAll = !value;
    this.dayOfWeek.forEach(item => item.isChecked = this.isCheckedAll);
  }

  onClickSelectDay(item: any) {
    item.isChecked = !item.isChecked;
    this.isCheckedAll = this.dayOfWeek.filter(d => d.isChecked).length === this.dayOfWeek.length;
  }

  // Validate form on submit
  checkValidate() {
    let isValid = true;
    this.isValidDateTime = false;
    this.isValidRepeatEvent = false;
    this.invalidTimeMsg = '';
    this.invalidRepeatEventMsg = '';
    for (const field in this.dateError) {
      this.dateError[field] = '';
    }
    for (const field in this.formError) {
      this.formError[field] = '';
      const control = this.eventFormGroup.get(field);
      if (control && control.invalid) {
        for (const key in control.errors) {
          const mess = this.messageError[field];
          if (control.errors.hasOwnProperty(key)) {
            this.formError[field] = mess[key];
          }
        }
      } else {
        if (control && field === 'summary' && control.value.trim() === '') {
          this.formError[field] = this.messageError[field].required;
          isValid = false;
        }
      }
    }

    if (this.dateOfEvent.startTime === '' || this.dateOfEvent.endTime === '') {
      this.dateError.startTime = !this.dateOfEvent.startTime ? this.messageError.startTime.required : '';
      this.dateError.endTime = !this.dateOfEvent.endTime ? this.messageError.endTime.required : '';
    } else if (this.dateOfEvent.startTime >= this.dateOfEvent.endTime) {
      this.invalidTimeMsg = this.messageError.endTime.invalid;
    } else {
      this.isValidDateTime = true;
    }

    return this.eventFormGroup.valid && this.isValidDateTime && this.checkRepeatEvent() && isValid;
  }

  // check repeat event
  checkRepeatEvent() {
    if (!this.isRepeatEvent) {
      return true;
    }
    const arrCheckedDay = this.dayOfWeek.filter(item => item.isChecked);
    if (this.repeatStartDate === '' || this.repeatEndDate === '' || arrCheckedDay.length === 0) {
      this.repeateDateError.repeatStartDate = this.repeatStartDate === '';
      this.repeateDateError.repeatEndDate = this.repeatEndDate === '';
      this.invalidRepeatEventMsg = 'Please select time repeat';
      return false;
    } else if (!moment(this.repeatStartDate).isSameOrBefore(this.repeatEndDate)) {
      this.repeateDateError.repeatStartDate = true;
      this.repeateDateError.repeatEndDate = true;
      this.invalidRepeatEventMsg = this.messageError.endDate.invalid;
      return false;
    } else {
      this.repeateDateError.repeatStartDate = false;
      this.repeateDateError.repeatEndDate = false;
      return true;
    }
  }

  setRRule() {
    const repeatDay = this.dayOfWeek.filter(item => item.isChecked).map(item => RRule[item.key]);
    // Create a rule:
    const rule = new RRule({
      freq: RRule.WEEKLY,
      byweekday: repeatDay,
      dtstart: new Date(this.repeatStartDate),
      until: new Date(this.repeatEndDate)
    });
    return rule.toString();
  }

  parseRRule(rrule: string) {
    const rruleObj = rrulestr(rrule);
    this.repeatStartDate = moment(this.prop.eventModel.start_date).format('YYYY-MM-DD');
    this.repeatEndDate = moment(this.prop.eventModel.end_date).format('YYYY-MM-DD');
    let countChecked = 0;
    for (let i = 0; i < rruleObj.options.byweekday.length; i++) {
      countChecked++;
      this.dayOfWeek[rruleObj.options.byweekday[i]].isChecked = true;
    }
    this.isCheckedAll = countChecked === this.dayOfWeek.length;
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/modal-event/modal-event.component.ts